var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRegistrationComplete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#F2F2F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.2527 46.3792L17.8027 45.5662C17.4501 45.5538 17.1035 45.472 16.7826 45.3253C16.4618 45.1785 16.173 44.9699 15.9331 44.7113C15.6931 44.4526 15.5066 44.1492 15.3842 43.8182C15.2619 43.4873 15.2062 43.1355 15.2202 42.783L16.3439 13.0855C16.3569 12.7331 16.4393 12.3868 16.5863 12.0663C16.7333 11.7458 16.942 11.4574 17.2004 11.2176C17.4589 10.9778 17.762 10.7912 18.0926 10.6686C18.4232 10.546 18.7747 10.4897 19.1271 10.5029L32.7338 11.0194L42.8564 22.2769L42.0417 43.7973C42.0136 44.5093 41.7042 45.181 41.1813 45.6651C40.6584 46.1492 39.9648 46.406 39.2527 46.3792V46.3792Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0746 19.1146C30.0541 19.2071 27.9273 19.2162 25.2779 19.1292C22.6286 19.0422 20.4807 18.8943 20.477 18.7965C20.4733 18.6987 22.6233 18.6993 25.2727 18.7863C27.9221 18.8733 30.0942 19.0265 30.0746 19.1146Z",
    fill: "#9B9A97"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4257 23.6886C36.4005 23.8022 32.8064 23.9157 28.3522 23.9368C23.898 23.958 20.2919 23.8703 20.2939 23.7687C20.2958 23.667 23.9131 23.5416 28.3674 23.5205C32.8216 23.4993 36.4301 23.5761 36.4257 23.6886Z",
    fill: "#9B9A97"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8505 27.6407C37.8284 27.7402 33.9421 27.7897 29.117 27.7272C24.2919 27.6646 20.398 27.5404 20.4016 27.4317C20.4052 27.323 24.3089 27.2877 29.1351 27.3453C33.9614 27.4029 37.8541 27.532 37.8505 27.6407Z",
    fill: "#9B9A97"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9581 31.3044C37.9349 31.4087 33.9527 31.4309 29.0053 31.3456C24.0579 31.2602 20.068 31.1037 20.07 30.9999C20.072 30.8962 24.0754 30.8734 29.0228 30.9588C33.9702 31.0442 37.9411 31.1913 37.9581 31.3044Z",
    fill: "#9B9A97"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6266 34.8713C37.6034 34.9756 33.7184 35.0194 28.8924 34.9609C24.0663 34.9024 20.1748 34.7676 20.1773 34.664C20.1798 34.5604 24.0855 34.5159 28.9115 34.5744C33.7375 34.6329 37.6291 34.7677 37.6266 34.8713Z",
    fill: "#9B9A97"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6033 38.3977C37.5801 38.502 33.6951 38.5458 28.8691 38.4873C24.043 38.4288 20.1515 38.294 20.154 38.1904C20.1565 38.0867 24.0622 38.0423 28.8882 38.1008C33.7142 38.1593 37.6058 38.2941 37.6033 38.3977Z",
    fill: "#9B9A97"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7338 11.0195L32.4229 19.3787C32.4084 19.708 32.4591 20.0369 32.572 20.3465C32.685 20.6561 32.858 20.9403 33.0811 21.1829C33.3042 21.4255 33.573 21.6216 33.8721 21.76C34.1712 21.8985 34.4947 21.9764 34.824 21.9895L42.8603 22.2951L32.7338 11.0195Z",
    fill: "#9B9A97"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1384 50.4002C44.4901 50.4002 47.2071 47.6832 47.2071 44.3315C47.2071 40.9798 44.4901 38.2627 41.1384 38.2627C37.7867 38.2627 35.0696 40.9798 35.0696 44.3315C35.0696 47.6832 37.7867 50.4002 41.1384 50.4002Z",
    fill: "#7BC974"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3674 44.4795L38.6526 43.2631L40.4269 44.8973L43.9201 41.6104L45.1894 42.8109L40.4084 47.3486L37.3674 44.4795Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegistrationComplete);
export default __webpack_public_path__ + "static/media/registrationComplete.a1670c7ef1bcd32e3d350bb834ca33e0.svg";
export { ForwardRef as ReactComponent };